import { createSlice } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  characterStyle: [],
};
const slice = createSlice({
  name: "characterStyle",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getCharacterStyle.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getCharacterStyle.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      characterStyle: payload.data,
    }));
    builder.addCase(Act.getCharacterStyle.rejected, (state, action) => ({
      ...state,
      loading: false,
      characterStyle: [],
    }));
  },
});
export default slice;
